import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getGroups = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/group?companyOldId=0`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const getB2ngGroups = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/group?companyOldId=1`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const setGroupUrl = async (group) => {
   return axios({
      method: "put",
      url: `${hostCloud}/group/main-page-url?mainPageUrl=${group.mainPageUrl}`,
      headers: {
         Accept: "*/*"
      },
      data: {
         ...group
      }
   });
};

export const changeGroupSidebarItems = async (group, items, option) => {
   if (!items.length) return;
   let addOrRemove;
   if (option === "add") addOrRemove = "add";
   else addOrRemove = "remove";
   const params = new URLSearchParams();
   items.forEach((item) => {
      params.append("tabsIds", item);
   });
   const paramsString = params.toString();
   // The data has to be like this or otherwise it won't work. This is a bit counter-intuitive but basically nothing you send in data matters, the correct format has to be there tho. It's just for finding the right group - what matters is paramsString
   return axios({
      method: "put",
      url: `${hostCloud}/group/side-bar-tab/${addOrRemove}?${paramsString}`,
      headers: {
         Accept: "*/*"
      },
      data: {
         ...group
      }
   });
};

export const getGroupMembers = async (groupId) => {
   const params = {
      groupOldId: +groupId,
      page: 1,
      itemsPerPage: 100000
   };
   return axios({
      method: "GET",
      url: `${hostCloud}/group/members`,
      headers: {
         Accept: "*/*"
      },
      params
   });
};
